import { IgMedia } from '@core/models/ApiFields/ig-entities';
import { REQ_MODE, RawDataWithBreakd } from '@core/models/IApi';
import { CHART_TYPE } from '@features/social-analysis/models/IChart';
import { Dimension } from '@features/social-analysis/models/IDimensions';
import { Filter } from '@features/social-analysis/models/IFilters';
import { ChartState } from '@features/social-analysis/social-shared/store/chart.store';
import { BaseState } from '@features/social-analysis/social-shared/store/state.store';
import { HttpBuilder } from '../../social-shared/services/http/http-builder';

export abstract class ChartHttpBuilder<T extends BaseState<any> = ChartState> extends HttpBuilder<
    T,
    RawDataWithBreakd
> {
    protected getFields(dims: Dimension[], metrics: Dimension[]) {
        const dimStr = dims.map(dim => dim.value).join();
        const metricStr = metrics.map(met => met.value).join();

        return { fields: dimStr + ',' + metricStr };
    }

    protected getSort(dims: Dimension[]) {
        const sortStr = dims
            .map(dim => {
                const dir = dim.type === CHART_TYPE.LINE ? 'asc' : 'desc';
                return `${dim.value}_${dir}`;
            })
            .join();

        return { sort: sortStr };
    }

    protected getMode() {
        return { mode: REQ_MODE.DATA };
    }

    protected getFilters(filters: Filter[]) {
        return { ...this.formatFilters(filters) };
    }

    protected getPostId(postId: string) {
        return { [IgMedia.getPrefixed('mediaId')]: 'eq:' + postId };
    }

    protected splitDims(dims: Dimension[]) {
        const dimFields = dims
            .filter(dim => !dim.fixed)
            .map(dim => dim.value)
            .join();
        const breakdowns = dims
            .filter(dim => dim.fixed)
            .map(dim => dim.value)
            .join();

        return [dimFields, breakdowns];
    }
}
